/* eslint-disable max-len */
import React from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const Facebook = ({
    title,
    titleId = "tm-icon-facebook",
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden={!title}
        role={title ? "img" : ""}
        aria-labelledby={titleId}
        height="1em"
        width="1em"
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M9 8H6v4h3v12h5V12h3.642L18 8h-4V6.333C14 5.378 14.192 5 15.115 5H18V0h-3.808C10.596 0 9 1.583 9 4.615V8z" />
    </svg>
);

export default Facebook;
